interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: RadioOption[];
  disabled?: boolean;
}

export function RadioGroup({ name, value, onChange, options, disabled = false }: RadioGroupProps) {
  return (
    <div className="space-y-2">
      {options.map((option) => (
        <label key={option.value} className="flex items-center">
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            className="mr-2 text-[#E34290] focus:ring-[#E34290]"
          />
          <span className="text-sm text-theme-light-text-primary dark:text-theme-dark-text-primary">
            {option.label}
          </span>
        </label>
      ))}
    </div>
  );
}
